import { Input } from 'antd';

import withFormItem from '../withFormItem';

export default withFormItem(Input);
